/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import OrderCM2PerDayChart from "./chart/OrderCM2PerDayChart";
import CommentList from "./CommentList";
import HelpNote from "./HelpNote";
import PatientLifecycle from "./PatientLifecycle";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Globals from "../shared/Globals";
import Auth from "../shared/Auth";
import FormLabel from "./FormLabel";
import { Link } from "react-router-dom";
import DataTable from "./DataTable";

class OrderSummary extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            hash: this.uuid()
        };
    }

    async componentDidMount() {
        await this.getSettings();
    }


    getSalesRepUser = () => {
        if (!this.props.userList) return null;
        if (this.props.item?.salesRepUserID) {
            var user = this.props.userList.find(i => i.id === this.props.item.salesRepUserID);
            if (user)
                return user;
        }
        return null;
    }

    change = () => {
        this.props.onChange?.();
        this.setState({ hash: this.uuid() });
    }

    render() {
        return <>
            {this.state.MODEL === 'WMS' && <PatientLifecycle order={this.props.item} onChange={this.change} />}

            <div className="row">
                <div className="col-md">

                    <Card title="Patient Details">
                        <div className="row">
                            <div className="col-md">
                                <FormLabel model={this.props.item.oid} label="ID#" />
                                {this.props.item.account.id !== 0 && <FormLabel model={this.props.item.account.name} label="Account" link={Auth.hasRole('manager') && `/account/${this.props.item.account.id}`} />}
                                {this.props.item.provider.id !== 0 && <FormLabel model={this.props.item.provider.name} label="Provider" link={Auth.hasRole('admin') && this.props.item.provider.id && `/provider/edit/${this.props.item.provider.id}`} />}
                                {this.props.item.referringProvider.id !== 0 && <FormLabel model={this.props.item.referringProvider.name} label="Referring Provider" link={Auth.hasRole('admin') && this.props.item.referringProvider.id && `/provider/edit/${this.props.item.referringProvider.id}`} />}
                                {this.props.item.practice.id !== 0 && <FormLabel model={this.props.item.practice.name} label="Practice" link={Auth.hasRole('admin') && this.props.item.practice.id && `/practice/edit/${this.props.item.practice.id}`} />}
                                {this.props.item.productName && <FormLabel model={this.props.item.productName} label="Product" />}
                                <FormLabel model={this.props.item.patientNameDOB} label="Patient" link={'/order/view/' + this.props.item.id + '/patient'} />
                                <FormLabel model={this.props.item.patient.genderLong} label="Patient Gender" />

                                {this.props.item.status === 'Discharge'
                                    ? <FormLabel model={`${this.props.item.status} (${this.props.item.dischargeStatusName})`} label="Status" />
                                    : <FormLabel model={this.props.item.status} label="Status" />}

                                {this.props.item.leadTAT ? <FormLabel model={this.props.item.leadTAT} label="Lead to Patient (TAT)" /> : null}
                                {this.state.MODELPROPS?.indexOf('WOUND') >= 0 && (this.props.item.totalProductSizeCM2 ? <FormLabel model={<>{this.props.item.totalProductSizeCM2} <span><L>cm</L><sup><L>2</L></sup></span></>} label="Total Product Applied" onClick={Auth.hasRole('manager') ? () => this.setState({ showProductsModal: true }) : null} /> : '')}

                                {this.getSalesRepUser()
                                    && <FormLabel model={this.getSalesRepUser().name} label="Care Coordinator" />}

                                {Auth.hasRole('manager') ? <HelpNote><L>Looking for the</L> <strong><L>Actions</L></strong> <L>dropdown? Find it at the bottom right of the screen.</L></HelpNote> : null}

                            </div>
                            {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <div className="col-md">
                                <div className="c-formlabel mb-3">
                                    <h5><L>Healing Progress by cm</L><sup><L>2</L></sup></h5>
                                </div>
                                <OrderCM2PerDayChart orderID={this.props.item.id} />
                            </div>}
                        </div>
                    </Card>
                    {this.state.MODEL === 'LIS' && <Card title="Specimens">
                        <DataTable columns={[
                            { name: 'sid', title: 'Specimen ID', valueFunc: row => <Link to={`/specimen/${row.id}`}>{row.sid}</Link> },
                            { name: 'collectedDate', title: 'Collected', valueFunc: row => row.isCollected ? Globals.toMDYHMLocalDateStringOrDiff(row.collectedDate, true, true) : <i><L><L>Pending</L></L></i> }
                        ]} data={this.props.item.specimens || []} />
                    </Card>}
                </div>
                <div className="col-md-4">
                    <Card title="Photo">
                        <img src={Globals.getStorageURL(this.props.item?.patient?.photoIdent, true)} alt="Patient" className="img-fluid" />
                    </Card>

                    {this.state.MODEL === 'EHR' && !this.props.item.patient?.photoIdent && <Card title="Photo"><img src={Globals.getStorageURL(null, true)} alt="Patient" className="img-fluid" /></Card>}



                </div>
            </div>
            {!Auth.hasRole('external') && <Card title="Activity and Comments">
                <CommentList orderId={this.props.item.id} hash={this.state.hash} />
            </Card>}
        </>;
    }
}

export default withParamsAndNavigate(OrderSummary);